function Container({ children }) {
  return (
    <div className="container-fluid">
        <div className="row px-0 px-sm-4">
            <div className="bg-boxshadow w-100">
                <div className="ibox-content">
                    { children }
                </div>
            </div>
        </div>
      </div>
  )
}

export default Container
